import { useState } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import '../App.css';
import RecentPost from "../RecentPost";
import ContactNumber from "../ContactNumber";
import { Helmet } from "react-helmet";

export default function WadgoanSheriPg(){
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
      setActiveIndex(activeIndex === index ? null : index);
    };
    
   
    const faqs = [
        {
            question: "What types of rooms are available at Om Sai PG in Wadgaon Sheri?",
            answer: "Om Sai PG offers a variety of rooms, including single, double, and triple-sharing rooms. Each room is fully furnished with necessary furniture like beds, study tables, wardrobes, and chairs for your comfort."
        },
        {
            question: "Are meals included in the rent?",
            answer: "Yes, home-cooked meals are included in the rent. We offer breakfast, lunch, and dinner with both vegetarian and non-vegetarian options, ensuring nutritious and delicious meals for all residents."
        },
        {
            question: "How much does the rent cost at Om Sai PG?",
            answer: "The rent at Om Sai PG is affordable and varies based on the type of room and sharing arrangement. The rent includes meals, Wi-Fi, electricity, water, and housekeeping services, making it a cost-effective living solution."
        },
        {
            question: "Is Wi-Fi available at Om Sai PG?",
            answer: "Yes, Om Sai PG offers high-speed Wi-Fi throughout the premises to ensure uninterrupted internet access for work, study, and leisure."
        },
        {
            question: "How secure is Om Sai PG?",
            answer: "Om Sai PG is equipped with 24/7 security personnel, CCTV surveillance, and a controlled access system to ensure the safety and security of all residents."
        },
        {
            question: "Are laundry and housekeeping services available?",
            answer: "Yes, Om Sai PG provides both laundry and housekeeping services to make your stay more convenient. Our housekeeping staff cleans your room regularly, and the laundry service ensures your clothes are well-maintained."
        },
        {
            question: "How far is Om Sai PG from Wadgaon Sheri?",
            answer: "Om Sai PG is located within Wadgaon Sheri, making it an ideal place for residents who work or study in the area. The location is well-connected to major parts of Pune, such as Kharadi, Hadapsar, and Magarpatta, ensuring easy accessibility to transport, educational institutions, and business hubs."
        },
        {
            question: "Can I bring guests to Om Sai PG?",
            answer: "Guests are allowed with prior permission from the management. We ensure that all visits are handled professionally while respecting the privacy of other residents."
        },
        {
            question: "Is parking available at Om Sai PG?",
            answer: "Yes, Om Sai PG provides parking facilities for residents with vehicles. The parking area is secure, ensuring the safety of your vehicle."
        },
        {
            question: "Is Om Sai PG suitable for both students and working professionals?",
            answer: "Yes, Om Sai PG is suitable for both students and working professionals. Its prime location, comfortable rooms, and top-notch amenities make it a perfect choice for anyone looking for a comfortable living space near Wadgaon Sheri."
        }
    ];
    
    const testimonials = [
        {
            quote: "I have been staying at Om Sai PG in Wadgaon Sheri for the past 4 months, and it has been an excellent experience. The rooms are spacious, and the amenities provided, such as Wi-Fi and meals, are fantastic. The food is delicious and home-cooked, and I always feel at home. The location is convenient for me as I work in Hadapsar. The security is top-notch, and I feel completely safe. I highly recommend Om Sai PG to anyone looking for a great place to stay.",
            author: "- Arvind Patil"
        },
        {
            quote: "Om Sai PG in Wadgaon Sheri is one of the best PG accommodations I’ve stayed in. The rooms are well-maintained, and the staff is very friendly and professional. The food is hygienic and tasty, and I love that the rent is very affordable, considering the amenities offered. It’s also very close to public transport, so commuting to work or college is hassle-free. I would highly recommend this PG to both students and working professionals.",
            author: "- Sneha Deshmukh"
        }
    ];
    

      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
      };
    
    
    
    
    return(
        <>

<Helmet>
  {/* JSON-LD Structured Data */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Om Sai PG",
      "description": "Om Sai PG offers affordable PG accommodations in Kharadi, Pune, with food, for students, working professionals, and residents, near Eon IT Park.",
      "url": "https://www.omsaipg.in/Wadgaon-Sheri-PG",
      "logo": "https://www.omsaipg.in/images/logo.jpg",
      "image": "https://www.omsaipg.in/img/keyword-image/wadgoan-sheri-pg.jpg",
      "contactPoint": [
        {
          "@type": "ContactPoint",
          "telephone": "+91 9763888448",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
        {
          "@type": "ContactPoint",
          "telephone": "+91 9922248255",
          "contactType": "Customer Service",
          "areaServed": "IN",
          "availableLanguage": "English",
        },
      ],
      "aggregateRating": {
        "@type": "AggregateRating",
        "bestRating": "5",
        "worstRating": "1",
        "ratingValue": "4.7",
        "ratingCount": "250",
      },
      "email": "omsaipg@gmail.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Tulja Bhavani Nagar, Lane No 7, Near Durga Mata Mandir",
        "addressLocality": "Kharadi",
        "addressRegion": "Maharashtra",
        "postalCode": "411014",
        "addressCountry": "IN",
      },
      "sameAs": [
        "https://www.facebook.com/omsaipg",
        "https://www.instagram.com/omsaipg",
        "https://www.linkedin.com/company/omsaipg"
      ],
      "priceRange": "INR 8,500-6000",
      "paymentAccepted": "Cash, UPI, Credit Card",
      "keywords": [
        "PG in Pune",
        "PG in Kharadi",
        "PG with food in Pune",
        "PG for students in Kharadi",
        "PG for females in Pune",
        "PG for males in Pune",
        "Om Sai PG Kharadi",
        "Girls Hostels in Kharadi",
        "Boys Hostel in Kharadi",
        "Monthly Basis PG in Kharadi",
        "PG in Wagholi",
        "PG in Kharadi with food",
        "Hostels in Pune",
        "PG for Students in Kharadi Pune",
        "Paying Guest Hostel in Chandan Nagar"
      ],
      "openingHours": "Mo-Su 09:00-22:00"
    })}
  </script>

  {/* Title */}
  <title>
    Om Sai PG - Affordable PG in Wadgaon Sheri, Kharadi | Girls Hostels in Kharadi | PG in Chandan Nagar
  </title>

  {/* Meta Tags */}
  <meta
    name="description"
    content="Om Sai PG offers affordable PG accommodations in Wadgaon Sheri, Kharadi, Pune. Providing PG for students, males, females, with food and all essential amenities."
  />
  <meta
    name="keywords"
    content="PG in Pune, PG in Kharadi, Wadgaon Sheri PG, PG in Chandan Nagar, Hostels in Kharadi, Girls Hostels in Kharadi"
  />
  <meta name="robots" content="index, follow" />

  {/* Open Graph Tags */}
  <meta
    property="og:title"
    content="Om Sai PG - Best PG Accommodation in Kharadi Pune | PG with Food | Paying Guest in Kharadi"
  />
  <meta
    property="og:description"
    content="Looking for the best PG in Kharadi Pune? Om Sai PG offers comfortable and affordable accommodation for students, professionals, and residents with food included."
  />
  <meta property="og:image" content="https://www.omsaipg.in/img/keyword-image/wadgoan-sheri-pg.jpg" />
  <meta property="og:url" content="https://www.omsaipg.in/Wadgaon-Sheri-PG" />
  <meta property="og:type" content="website" />
</Helmet>

     <section class="section-breadcrumb padding-b-50">
        <div class="rx-breadcrumb-image bg-img2">
            <div class="rx-breadcrumb-overlay"></div>
            <div class="inner-breadcrumb-contact">
                <div class="main-breadcrumb-contact">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="rx-banner-contact">
                                    <h2>Wadgaon Sheri PG</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rx-banner-breadcrumb">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="breadcrumb-contact">
                                    <div class="main-heading">
                                        <h4>Wadgaon Sheri PG  </h4>
                                    </div>
                                    <div class="last-contact">
                                        <ul>
                                            <li>
                                                <Link to="/">Home</Link>
                                            </li>
                                            <li>Wadgaon Sheri PG </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

      {/* <!-- Page Banner End --> */}

      <div class="section-about padding-tb-50 keywordsection">
        <div className="container">
          <div className="row d-flex justify-content-around">
            <div className="col-12 col-md-8">
              <div className="keyword-img">
                <img src="img/keyword-image/wadgoan-sheri-pg.jpg" className="img-fluid" alt="wadgoan-sheri-pg" />
              </div>
             
              <h1>Best Paying Guest (PG) Accommodation in Wadgaon Sheri, Pune</h1>

<p>Wadgaon Sheri is a rapidly growing locality in Pune, known for its proximity to major IT hubs, educational institutes, and key transportation routes. Whether you're a working professional in the tech industry or a student, finding a comfortable and affordable PG accommodation in Wadgaon Sheri can make a big difference in your daily life.</p>

<p>Om Sai PG offers one of the best living options in Wadgaon Sheri, with top-notch facilities designed to ensure comfort and convenience. Let’s take a closer look at why Om Sai PG is the perfect choice for you.</p>

<h2>Why Choose Om Sai PG in Wadgaon Sheri?</h2>
<p>Om Sai PG is located in the vibrant area of Wadgaon Sheri, offering a safe, secure, and peaceful environment for both working professionals and students. Our PG rooms are fully equipped with modern amenities, and the area itself is well-connected to important locations like Viman Nagar, Kharadi, and Kalyani Nagar, making it an ideal choice for those working or studying in Pune.</p>

<h2>Facilities at Om Sai PG</h2>
<p>Om Sai PG is equipped with all the necessary amenities to ensure a comfortable and convenient stay:</p>

<ul>
  <li><strong>Washing Machine</strong> – We provide washing machine facilities to make laundry hassle-free.</li>
  <li><strong>High-Speed Wi-Fi</strong> – Stay connected with our high-speed internet available 24/7.</li>
  <li><strong>TV in Every Room</strong> – Enjoy entertainment and unwind in your private room with a television.</li>
  <li><strong>24/7 Water Supply</strong> – Never run out of water with our continuous water supply.</li>
  <li><strong>Geyser</strong> – Enjoy hot water whenever you need it with our geyser facilities.</li>
  <li><strong>2-Wheeler Parking</strong> – Safe and secure parking available for your two-wheeler.</li>
  <li><strong>Fridge</strong> – Keep your groceries and food fresh with a fridge in the room.</li>
  <li><strong>Gas Facility</strong> – For those who prefer to cook, gas connections are available.</li>
  <li><strong>24-Hours Hot Water</strong> – Hot water available round-the-clock for your comfort.</li>
  <li><strong>Free Housekeeping</strong> – We offer housekeeping services to maintain cleanliness and hygiene.</li>
  <li><strong>Free Electricity</strong> – No additional electricity bills; it’s all included in your rent.</li>
  <li><strong>Purified Drinking Water</strong> – We provide purified drinking water for your health and safety.</li>
  <li><strong>CCTV Security</strong> – CCTV surveillance ensures that your safety is a top priority.</li>
</ul>

<h2>Rent Details and Room Types</h2>
<p>Om Sai PG offers affordable rooms with inclusive meals:</p>
<ul>
  <li><strong>Sharing Room 1:</strong> ₹8,500/month (Including Breakfast and Dinner)</li>
  <li><strong>Sharing Room 2:</strong> ₹7,000/month (Including Breakfast and Dinner)</li>
  <li><strong>Sharing Room 3:</strong> ₹6,000/month (Including Breakfast and Dinner)</li>
</ul>

<h3>Additional Information</h3>
<ul>
  <li><strong>Security Deposit:</strong> ₹3,000 (Refundable)</li>
  <li><strong>One-Month Advance Rent</strong> is required at the time of booking.</li>
</ul>

<h2>Location Benefits of Wadgaon Sheri</h2>
<p>Wadgaon Sheri is strategically located with easy access to all the major IT hubs, educational institutes, and other important areas like Viman Nagar, Kharadi, and Kalyani Nagar. The locality is well-connected by public transportation, and you’ll find plenty of shopping centers, restaurants, hospitals, and other amenities within close proximity.</p>

<h2>Contact Us</h2>
<p>For more details or to book your room at Om Sai PG, reach out to us:</p>
<ul>
  <li>9763888448</li>
  <li>9922248255</li>
</ul>



<h1>Vadgaon Sheri PG</h1>

<p>Vadgaon Sheri offers a variety of PG accommodations suited to the needs of students and working professionals. These PGs are well-equipped with modern amenities such as Wi-Fi, nutritious meals, 24/7 security, and laundry services. The area is well-connected to major IT hubs, educational institutions, and transport facilities, making it an ideal choice for those looking for comfort and convenience.</p>

<h2>PG Near Wadgaon Sheri</h2>
<p>If you're looking for a PG near Wadgaon Sheri, there are several affordable and well-maintained options available. These PGs are located close to major business and educational centers, providing a comfortable living space with essential services like food, Wi-Fi, and security. The area is ideal for students and professionals, offering easy access to major transportation links.</p>

<h2>PG in Wadgaon Sheri for Male</h2>
<p>For male professionals or students, PGs in Wadgaon Sheri are available with various accommodation options. These PGs come with spacious rooms, Wi-Fi, home-cooked meals, and security, ensuring a hassle-free stay. With proximity to nearby tech parks, colleges, and shopping centers, these PGs are perfect for males looking for a well-connected place to stay.</p>

<h2>PG in Wadgaon Sheri for Female</h2>
<p>If you're a female searching for a PG in Wadgaon Sheri, you’ll find several ladies PGs that provide a safe and secure environment. These PGs offer well-furnished rooms, nutritious meals, Wi-Fi, and 24/7 security. Whether you’re a student or a working professional, PGs in Wadgaon Sheri for females offer comfort and privacy, with easy access to public transport and other essential amenities.</p>

<h2>PG Hostel in Wadgaon Sheri</h2>
<p>For those looking for a PG hostel in Wadgaon Sheri, there are options that offer a homely atmosphere with shared and private rooms. These hostels provide essential services such as food, Wi-Fi, and round-the-clock security. With affordable pricing and convenient locations, PG hostels in Wadgaon Sheri are suitable for both students and professionals.</p>

<h2>PG in Wadgaon Sheri</h2>
<p>There are several PGs in Wadgaon Sheri that offer comfortable living spaces for both students and working professionals. These PGs are equipped with the necessary amenities like meals, Wi-Fi, and security. The location ensures easy connectivity to major educational and business hubs, making PGs in Wadgaon Sheri a convenient and affordable option for anyone looking for accommodation in the area.</p>

<h2>PG Near Viman Nagar</h2>
<p>If you're looking for a PG near Viman Nagar, the area offers a variety of PGs suited to different needs. Located near key areas like Symbiosis and Phoenix Mall, these PGs offer easy access to schools, tech parks, and shopping centers. Amenities such as Wi-Fi, meals, and security are provided, ensuring a comfortable stay. Whether you’re looking for a shared room or a private space, PGs near Viman Nagar have options to suit your requirements.</p>

<h2>Viman Nagar PG</h2>
<p>Viman Nagar PGs are perfect for students and professionals who need accommodation near Viman Nagar, one of Pune’s most sought-after localities. These PGs offer spacious rooms, nutritious meals, Wi-Fi, and laundry services, ensuring convenience and comfort. Proximity to key institutions like Symbiosis and shopping malls like Phoenix Mall makes Viman Nagar an ideal choice for living.</p>

<h2>PG in Viman Nagar for Male</h2>
<p>For male professionals and students, there are several PGs in Viman Nagar offering shared and private room options. These PGs provide all the necessary facilities such as high-speed internet, meals, and 24/7 security. The strategic location near IT hubs, educational institutions, and shopping centers makes PGs in Viman Nagar for males a great option for a comfortable and convenient stay.</p>

<h2>PG Near Symbiosis Viman Nagar</h2>
<p>If you're studying at Symbiosis or working in the area, PGs near Symbiosis Viman Nagar provide easy access to the university and surrounding IT parks. These PGs offer excellent services such as meals, Wi-Fi, and security, ensuring a hassle-free stay. Whether you're a student or a professional, PGs near Symbiosis ensure comfort and convenience with a great location.</p>

<h2>PG Near Viman Nagar for Female</h2>
<p>For females seeking accommodation in Viman Nagar, there are plenty of ladies PGs available. These PGs provide a safe, secure, and comfortable environment with amenities like nutritious meals, Wi-Fi, laundry services, and 24/7 security. With easy access to nearby educational institutions like Symbiosis and shopping malls like Phoenix Mall, PGs near Viman Nagar for females ensure convenience and comfort.</p>

<h2>PG Near Phoenix Mall Viman Nagar</h2>
<p>PGs near Phoenix Mall Viman Nagar are ideal for those who want a lively, well-connected place to stay. These PGs provide spacious rooms, nutritious food, Wi-Fi, and 24/7 security, along with proximity to Phoenix Mall and other commercial hubs in Viman Nagar. Whether you’re a student or a working professional, PGs near Phoenix Mall offer convenience and comfort at affordable rates.</p>

<h2>PG in Viman Nagar Near Phoenix Mall</h2>
<p>If you're looking for a PG in Viman Nagar near Phoenix Mall, several options provide excellent accommodation choices with all necessary amenities. These PGs offer easy access to Phoenix Mall, IT parks, and Symbiosis. With meals, security, and Wi-Fi included, PGs near Phoenix Mall in Viman Nagar are perfect for students and professionals seeking both comfort and convenience.</p>

<h2>PG Near Phoenix Mall Pune</h2>
<p>This area is home to a range of PGs offering all essential services like meals, internet, and security. The location is ideal for students attending Symbiosis or professionals working in nearby IT parks. With easy access to shopping, dining, and entertainment options, PGs near Phoenix Mall Pune offer great living experiences.</p>

<h2>Paying Guest Near Me for Female</h2>
<p>If you're searching for a paying guest near me for female, there are various options available that offer secure and affordable accommodations with services like meals, Wi-Fi, and 24/7 security. These paying guest accommodations are ideal for students and working professionals who want a safe and homely environment.</p>

<h2>Paying Guest Near Me</h2>
<p>There are numerous options available for both males and females, offering secure, comfortable living spaces. With services like meals, Wi-Fi, and laundry, these paying guest accommodations ensure a hassle-free stay. Depending on your preferences, you can find shared or private room options in a variety of locations.</p>

<h2>Single Room PG in Pune</h2>
<p>If you're looking for a single room PG in Pune, you’ll find a variety of options offering privacy, comfort, and all necessary amenities like meals, Wi-Fi, and 24/7 security. These PGs cater to students and working professionals who prefer their own space while being close to key areas like IT parks, educational institutions, and shopping centers.</p>







            <h2>Om Sai PG for "PG In Pune" Contact Number:- </h2>
            <p>Contact Om Sai PG at +91 9763888448 / +91 9922248255. Our PG is strategically located in the heart of Kharadi, one of Pune's most vibrant and accessible neighborhoods, making it an ideal choice for students and professionals alike.</p>

            
              <table
                style={{
                  borderCollapse: "collapse",
                  width: "100%",
                  borderWidth: "0px",
                }}
                border="1"
              >
                <colgroup>
                  <col style={{ width: "49.9491%" }} />
                  <col style={{ width: "49.9491%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - Vadgaon Sheri PG</p>
<p> - PG Near Wadgaon Sheri</p>
<p> - PG in Wadgaon Sheri for Male</p>
<p> - PG in Wadgaon Sheri for Female</p>
<p> - PG Hostel in Wadgaon Sheri</p>
<p> - PG in Wadgaon Sheri</p>
<p> - PG Near Viman Nagar</p>
<p> - Viman Nagar PG</p>


                    </td>
                    <td style={{ borderWidth: "0px" }}>
                    <p> - PG in Viman Nagar for Male</p>
<p> - PG Near Symbiosis Viman Nagar</p>
<p> - PG Near Viman Nagar for Female</p>
<p> - PG Near Phoenix Mall Viman Nagar</p>
<p> - PG in Viman Nagar Near Phoenix Mall</p>
<p> - PG Near Phoenix Mall Pune</p>
<p> - Paying Guest Near Me for Female</p>
<p> - Paying Guest Near Me</p>
<p> - Single Room PG in Pune</p>


                    </td>
                  </tr>
                </tbody>
              </table>

              <h1>Why Choose Om Sai PG in Wadgaon Sheri, Pune?</h1>

<ul>
    <li><strong>1. Prime Location in Wadgaon Sheri</strong>
        <p>Om Sai PG is strategically located in Wadgaon Sheri, a rapidly developing area in Pune that offers excellent connectivity to key locations such as Kharadi, Magarpatta, and Hadapsar. The PG is conveniently located near major educational institutions, business hubs, and shopping areas, making it an ideal choice for both students and professionals.</p>
    </li>
    <li><strong>2. Comfortable and Fully Furnished Rooms</strong>
        <p>Om Sai PG offers fully furnished rooms that cater to your comfort and convenience. Each room is equipped with essential furniture, such as a bed, study table, wardrobe, and chair. We ensure that our rooms provide a relaxing atmosphere where you can work, study, and rest peacefully.</p>
    </li>
    <li><strong>3. Affordable Rent with All-Inclusive Amenities</strong>
        <p>The rent at Om Sai PG is affordable and includes a wide range of services. With a single rent, you get meals, high-speed Wi-Fi, electricity, water, and housekeeping services, making it easy to manage your budget without worrying about additional costs.</p>
    </li>
    <li><strong>4. Nutritious and Home-Cooked Meals</strong>
        <p>Our PG offers home-cooked, nutritious meals that cater to both vegetarian and non-vegetarian diets. The meals are freshly prepared daily, offering a variety of options to satisfy different tastes and dietary requirements, ensuring that our residents stay healthy and energized.</p>
    </li>
    <li><strong>5. High-Speed Wi-Fi for Seamless Connectivity</strong>
        <p>Om Sai PG provides high-speed Wi-Fi throughout the premises, making it easier for residents to stay connected for work, study, and personal use. Whether you're attending online classes, working remotely, or streaming content, our reliable internet connection ensures uninterrupted access.</p>
    </li>
    <li><strong>6. 24/7 Security with CCTV Surveillance</strong>
        <p>We prioritize your safety and peace of mind. Om Sai PG is equipped with 24/7 security personnel and CCTV surveillance to ensure that the premises are secure at all times. Our controlled access system ensures that only authorized individuals can enter the building.</p>
    </li>
    <li><strong>7. Cleanliness and Hygiene</strong>
        <p>We maintain high standards of cleanliness and hygiene in every part of Om Sai PG. Our housekeeping staff regularly cleans the rooms, bathrooms, and common areas to ensure a clean and healthy environment for all residents.</p>
    </li>
    <li><strong>8. Laundry and Housekeeping Services</strong>
        <p>To add convenience to your stay, Om Sai PG provides both laundry and housekeeping services. This allows you to focus on your work or studies while we take care of the chores like cleaning your room and washing your clothes.</p>
    </li>
    <li><strong>9. Spacious Common Areas</strong>
        <p>Om Sai PG offers spacious common areas where residents can relax, socialize, or even study. These areas are designed to foster a sense of community while offering comfort and space for personal downtime.</p>
    </li>
    <li><strong>10. Friendly and Supportive Management</strong>
        <p>Our friendly management team is always available to assist with any concerns or requests you may have. Whether you need help with meal preferences or assistance with any issues, our team is dedicated to ensuring your stay is comfortable and hassle-free.</p>
    </li>
</ul>


              
              <div className="">
                  <h2>
                  FAQs for Om Sai PG in Wadgaon Sheri, Pune ? 
                  </h2>
                  {faqs.map((faq, index) => (
                    <div key={index} className="faq-item">
                      <div
                        className={`faq-question ${
                          activeIndex === index ? "active" : ""
                        }`}
                        onClick={() => toggleAccordion(index)}
                      >
                        {index + 1}. {faq.question}
                      </div>
                      {activeIndex === index && (
                        <div className="faq-answer">{faq.answer}</div>
                      )}
                    </div>
                  ))}
                </div>


                  {/* ======================== */}
                  <div className="container">
                    <div className="testimonial-section">
                  <h2>
                  Testimonial for Om Sai PG in Wadgaon Sheri :- {" "}
                  </h2>
                  <Slider {...settings}>
                    {testimonials.map((testimonial, index) => (
                      <div key={index} className="testimonial-slide">
                        <blockquote>
                          <p>{testimonial.quote}</p>
                          <footer>— {testimonial.author}</footer>
                        </blockquote>
                      </div>
                    ))}
                  </Slider>
                  </div>
                </div>

                {/* ================= */}
                <ContactNumber></ContactNumber>
            </div>
           <RecentPost></RecentPost>
        
        </div>
        </div>
      </div>
    </>
  );
}
